import { render, staticRenderFns } from "./dragLayer.vue?vue&type=template&id=10ed00f0&"
import script from "./dragLayer.vue?vue&type=script&lang=js&"
export * from "./dragLayer.vue?vue&type=script&lang=js&"
import style0 from "./dragLayer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports